var map = {
	"./partner1.png": 2784,
	"./partner10.png": 4950,
	"./partner11.png": 5673,
	"./partner12.png": 5671,
	"./partner13.png": 3455,
	"./partner14.png": 3853,
	"./partner15.png": 3256,
	"./partner16.png": 8955,
	"./partner17.png": 4394,
	"./partner18.png": 7176,
	"./partner19.png": 9470,
	"./partner2.png": 3714,
	"./partner20.png": 7018,
	"./partner21.png": 4360,
	"./partner22.png": 5270,
	"./partner23.png": 635,
	"./partner24.png": 1390,
	"./partner3.png": 7785,
	"./partner4.png": 1541,
	"./partner5.png": 6029,
	"./partner6.png": 8193,
	"./partner7.png": 4605,
	"./partner8.png": 5980,
	"./partner9.png": 8205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1113;